import Base from "../base.store";
import lodash from "lodash";
import moment from "moment";
import { cacheTime } from "../../../../utils/constant";
import { filter } from "../../../../utils/search";

const baseUrl = "/api/v1/master/lookups";
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {
        listGroup: {},
        cacheDate: {
            listGroup: {},
        },
    }),
    getters: {
        ...base.getters,
    },
    actions: {
        ...base.actions,
        cacheFindAllByGroup(context, { group, key, value, where = [], options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listGroup[group];
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            if (key) {
                where.push({ name: "key", operator: "like", value: key });
            }
            if (value) {
                where.push({ name: "value", operator: "like", value: value });
            }
            const sort = [{ name: "seq", type: "asc" }];
            const list = context.state.listGroup[group] || [];
            if (list.length > 0 && !force) {
                return filter({ list: lodash.cloneDeep(list), where, sort });
            }
            return context.dispatch("findAllByGroup", { group }).then((list) => filter({ list, where, sort }));
        },
        findAllByGroup(context, { criteria, config, group }) {
            criteria = lodash.merge(
                {
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "seq", type: "ASC" }],
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "group", type: "String", operator: "=", value: group },
                    ],
                },
                criteria
            );
            return context.dispatch("search", { criteria, config }).then((page) => {
                const list = page.data;
                context.commit("setListGroupResult", { group, list });
                return list;
            });
        },
    },
    mutations: {
        ...base.mutations,
        setListGroupResult(state, { group, list }) {
            state.listGroup[group] = list;
            state.cacheDate.listGroup[group] = moment().add(cacheTime, "ms");
        },
    },
};
